export class SpeedConverter {
	static toImperial(value: number): number {
		return (value * 2.23693629);
	}

	static toMetric(value: number): number {
		return (value / 2.23693629);
	}
}